import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';

@Component({
    selector: 'app-custom-token',
    templateUrl: './custom-token.component.html',
    styleUrls: ['./custom-token.component.scss']
})
export class CustomTokenComponent implements OnInit {
    loading = true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private auth: AuthService
    ) {
    }

    ngOnInit(): void {
        const {token} = this.route.snapshot?.queryParams;

        if (token) {
            this.auth.activateUserByToken(token)
                .then((user) => {
                    this.loading = false;
                    this.router.navigate(['/']);
                })
                .catch((err: any) => {
                    this.router.navigate(['/']);
                    this.loading = false;
                });
        } else {
            this.router.navigate(['/']);
        }
    }

}
